import React from 'react';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import './RadioButton.scss';

const ThreeppRadioButton = props => {
  const { onChange, selected, label, value, color, disabled } = props;
  const radioColor = color || 'primary';
  return (
    <FormControlLabel
      control={<Radio onChange={onChange} checked={selected} disabled={disabled} value={value} className="threepp-radio-button" color={radioColor} />}
      label={label}
      classes={{
        root: 'threepp-radio-button-wrapper',
        label: 'threepp-radio-button-label'
      }}
    />
  );
};

export default ThreeppRadioButton;
